import { BusinessUnit } from "../../../Models/BusinessUnit";
import { Center } from "../../../Models/Center";
import { CustomDimension } from "../../../Models/CustomDimension";
import { DisqualifyingReason } from "../../../Models/DisqualifyingReason";
import { DynamicContent } from "../../../Models/DynamicContent";
import { AreaOfInterest } from "../../Playbook/Interests/Types/AreaOfInterest";

interface IPendingLoginDependencies {
  /** The options that are selectable by the user when identifying guest interests. */
  areasOfInterest: AreaOfInterest[] | null;
  /** The business units that should be supported for booking by the application. */
  businessUnits: BusinessUnit[] | null;
  /** The options that are allowed for designation of a booking location or a customer affiliation. */
  centers: Center[] | null;
  /** The recognized options of reasons why a customer may not be a candidate for business services. */
  disqualifyingReasons: DisqualifyingReason[] | null;
  /** The content to be rendered in the 'Dynamic Content' area of the session UI. */
  dynamicContent: DynamicContent[] | null;
  /** The options that are allowed when electing the ultimate result of session. */
  leadResultTypes: CustomDimension<number>[] | null;
  /** The options available when designating procedures that the customer is interested in that are not offered by the
   * business.
   */
  notOfferedProcedures: CustomDimension<string>[] | null;
}

export type LoginDependencies = { [P in keyof PendingLoginDependencies]: NonNullable<PendingLoginDependencies[P]> };

/** A roster of various application entities that are required by the application before it can provide full
 * functionality to a user.
 */
export class PendingLoginDependencies implements IPendingLoginDependencies {
  /** The options that are selectable by the user when identifying guest interests. */
  areasOfInterest: AreaOfInterest[] | null;
  /** The business units that should be supported for booking by the application. */
  businessUnits: BusinessUnit[] | null;
  /** The options that are allowed for designation of a booking location or a customer affiliation. */
  centers: Center[] | null;
  /** The recognized options of reasons why a customer may not be a candidate for business services. */
  disqualifyingReasons: DisqualifyingReason[] | null;
  /** The content to be rendered in the 'Dynamic Content' area of the session UI. */
  dynamicContent: DynamicContent[] | null;
  /** The options that are allowed when electing the ultimate result of session. */
  leadResultTypes: CustomDimension<number>[] | null;
  /** The options available when designating procedures that the customer is interested in that are not offered by the
   * business.
   */
  notOfferedProcedures: CustomDimension<string>[] | null;

  constructor() {
    this.areasOfInterest = null;
    this.businessUnits = null;
    this.centers = null;
    this.disqualifyingReasons = null;
    this.dynamicContent = null;
    this.leadResultTypes = null;
    this.notOfferedProcedures = null;
  }

  /** Validates of the given dependencies are all populated and returns them if so, null otherwise. */
  static GetComplete = (deps: PendingLoginDependencies): LoginDependencies | null => {
    if (
      !deps.areasOfInterest ||
      !deps.businessUnits ||
      !deps.centers ||
      !deps.disqualifyingReasons ||
      !deps.dynamicContent ||
      !deps.leadResultTypes ||
      !deps.notOfferedProcedures
    )
      return null;
    return deps as LoginDependencies;
  };
}
